export default {
    login : 'Login',
    forgot_password : 'Forgot Password',
    login_your_account : 'Please login to your account.',
    email : 'Email',
    password : 'Password',
    next : 'Next',
    auth : '2 Way Authentication',
    auth_setup : '2 Way Authentication SETUP',
    google_app_download : 'Download the GOOGLE AUTHENTICATOR APP on your phone to login with this email for first time. Scan the QR code below with the Google Auth app.',
    enter_code : 'Enter Code',
    open_auth : 'Open the Google Authenticator app and input the code below',
    validation : {
        enter_email : 'Please enter email',
        enter_valid_email : 'Please enter valid email',
        enter_password : 'Please enter password',
        enter_code : 'Please enter code',
        enter_valid_code : 'Please enter valid code'
    }
}